import React, { Component } from "react";
import $ from "jquery";
import "magnific-popup";

class Gallery extends Component {
  // eslint-disable-next-line
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    function popup() {
      $(".gallery-thumb").magnificPopup({
        type: "image",
        gallery: {
          enabled: true,
        },
      });
    }
    popup();
  }
  render() {

    const galleryImage = this?.props

    return (
      <div style={{ backgroundColor: galleryImage.websiteBackgroundColor, padding: '20px' }}>
        <div className="section p-0">
          <div className="gallery-section">
            <div className="row">
              {galleryImage?.gallery.map((item, index) => (
                <div
                  key={item?._id}
                  className="col-xl-3 col-lg-3 col-md-3 col-6 mobile-gallery"
                  style={{ padding: '10px' }}
                >
                  <a href={item?.image_url} className="gallery-thumb">
                    <img src={item?.image_url} alt="post" className="gallery-image" />
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Gallery;
